import { render, staticRenderFns } from "./postNetwork.vue?vue&type=template&id=401fa322&scoped=true"
import script from "./postNetwork.vue?vue&type=script&lang=js"
export * from "./postNetwork.vue?vue&type=script&lang=js"
import style0 from "./postNetwork.vue?vue&type=style&index=0&id=401fa322&prod&scoped=true&lang=css"
import style1 from "./postNetwork.vue?vue&type=style&index=1&id=401fa322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401fa322",
  null
  
)

export default component.exports